import styled from 'styled-components';

interface MessageContainerProps {
  $isUser: boolean;
}

export const MessageContainer = styled.div<MessageContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  align-self: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
  background-color: ${({ $isUser, theme }) => ($isUser ? theme.colors.primary[50] : 'transparent')};
  border-radius: ${({ theme }) => theme.spacing(2)}px;
  max-width: 80%;
`;

export const MessageBubble = styled.div<MessageContainerProps>`
  background-color: ${({ $isUser, theme }) => ($isUser ? theme.colors.primary[50] : 'transparent')};
  color: ${({ $isUser, theme }) => ($isUser ? theme.colors.primary[600] : theme.colors.on[600])};
  border-radius: ${({ theme }) => theme.spacing(2)}px;
  padding: ${({ theme }) => `${theme.spacing(2)}px`};
  word-wrap: break-word;
  white-space: pre-wrap;
`;
